import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import {getBasicHeaders, getHeadersWithFormData, normalizeUrl} from '@/common/utils/utils';
import { wrapAction } from '@/common/utils/actionLifecycle';
import FileSaver from 'file-saver';
import { featureEventObject } from '../store.constant';
import {
    prepareFeatureItemsForDragDrop,
    communityCommonConstant,
} from '@/components/ChapterPage/communityCommon.constant';
import { fileDragDropState, fileDragDropActions, fileDragDropGetters } from '../modules/chapter/fileDragDrop';
import {
    filesAndMediaState,
    filesAndMediaMutations,
    filesAndMediaActions,
    filesAndMediaGetters,
} from '../modules/chapter/filesAndMedia';
import {
    chapterAdminDetailsState,
    chapterAdminDetailsMutations,
    chapterAdminDetailsActions,
    chapterAdminDetailsGetters,
} from '../modules/chapter/chapterAdminDetails';
import orderBy from 'lodash/orderBy';
import { routerNames } from '@/components/appCommon.constants';
import { makeYearMonthDate } from '@/common/utils/dateTime';
import uniqBy from 'lodash/uniqBy';
import { getAxiosCancelTokenSource } from '@/app.utils';
import { myToolsConstants } from '../../components/Tools/mytools.constant';

const chapterPageState = () => {
    return {
        baseURL: process.env.VUE_APP_BASE_URL,
        isCommunityAdmin: false,
        isCommunityModerated: false,
        communitySalesforceId: '',
        activityFeedList: null,
        nextActivityFeedListPageNumber: 1,
        nextHomePageSkip: 0,
        postEdits: {},
        postChangesPending: {},
        chairMessage: {},
        showMoreTriggeredPost: {},
        showMoreTriggeredPostForAdmin: {},
        hiddenPostList: {},
        hiddenCommentList: {},
        chapterAwards: {},
        aboutView: null,
        transactionHubContent: {},
        commentedUsers: {},
        likedUsers: {},
        usersCommunitiesList: null,
        usersChaptersListPromise: new Promise(() => {}),
        prospectsList: {
            prospects: null,
            canVote: false,
            canSeeVotes: false,
        },
        votes: {
            prospectId: null,
            vote: null,
        },
        voted: null,
        featureEvents: null,
        featureEventInEdit: null,
        userHasVoted: null,
        adminFeedList: null,
        ...fileDragDropState,
        ...filesAndMediaState,
        ...chapterAdminDetailsState,
        chapterList: [],
        allChapterList: null,
        upcomingEventList: null,
        chapterOfficersData: {
            primaryOfficers: [],
            otherOfficers: [],
        },
        prospectDownloadInProgress: false,
        moderatedPostCreated: false,
        noMoreActivityToFetch: false,
        disableInfiniteScroll: false,
        communityInfo: null,
        chapterHealthScore: '',
        isPMTeamMember: false,
        businessCommunityId: null,
        unRegisteredEvents: null,
        errorFetchingCommunityData: false,
        chapterMessage: {},
        chapterQuickLinks: [],
        isMainActivityFeedHidden: false,
    };
};

const chapterPageMutations = {
    ...filesAndMediaMutations,
    ...chapterAdminDetailsMutations,
    [storeMutation.setChapterQuickLinks]: (state, data) => {
        state.chapterQuickLinks = data;
    },
    [storeMutation.setIsCommunityAdmin]: (state, isCommunityAdmin) => {
        state.isCommunityAdmin = isCommunityAdmin;
    },
    [storeMutation.setIsCommunityModerated]: (state, isCommunityModerated) => {
        state.isCommunityModerated = isCommunityModerated;
    },
    [storeMutation.setModeratedPostCreated]: (state, data) => {
        state.moderatedPostCreated = data;
    },
    [storeMutation.setChapterActivityList]: (state, data) => {
        if (state.activityFeedList && state.activityFeedList.length) {
            let newItemPused = false;
            data.forEach((item) => {
                item.name = '';
                if (state.usersCommunitiesList.some(o => o.communityId === item.communityId)) {
                    item.name = state.usersCommunitiesList.find(o => o.communityId === item.communityId).name;
                }
                const alreadyExist = state.activityFeedList.some(it => it.id === item.id);
                if (!alreadyExist) {
                    state.activityFeedList.push(item);
                    newItemPused = true;
                }
            });
            if (newItemPused) {
                state.activityFeedList = uniqBy(state.activityFeedList, 'id');
                state.nextActivityFeedListPageNumber += 1;
                state.nextHomePageSkip += communityCommonConstant.post.searchResultOffsetStep;
            }
        } else {
            state.activityFeedList = uniqBy(data, 'id');
            state.nextActivityFeedListPageNumber += 1;
            state.nextHomePageSkip += communityCommonConstant.post.searchResultOffsetStep;
        }
        state.activityFeedList.forEach((item) => {
            item.name = '';
            if (
                state.usersCommunitiesList &&
                state.usersCommunitiesList.some(o => o.communityId === item.communityId)
            ) {
                item.name = state.usersCommunitiesList.find(o => o.communityId === item.communityId).name;
            }
        });
    },
    [storeMutation.resetChapterActivityList]: (state) => {
        state.activityFeedList = null;
        state.nextActivityFeedListPageNumber = 1;
        state.nextHomePageSkip = 0;
        state.noMoreActivityToFetch = false;
        state.disableInfiniteScroll = false;
    },
    [storeMutation.setInfiniteScrollState]: (state, val) => {
        state.disableInfiniteScroll = val;
    },
    [storeMutation.setAdminFeedList]: (state, data) => {
        state.adminFeedList = data;
    },

    [storeMutation.setChapterMessage]: (state, data) => {
        state.chapterMessage = data || {};
    },
    [storeMutation.setusersCommunitiesList]: (state, data) => {
        state.usersCommunitiesList = data;
    },
    [storeMutation.removeResignedCommunityId]: (state, communityId) => {
        state.usersCommunitiesList = state.usersCommunitiesList.filter(item => item.communityId !== communityId);
    },

    //Feature Events
    [storeMutation.updateFeatureEvents]: (state, data) => {
        if (data) {
            prepareFeatureItemsForDragDrop(data);
            if (data && data.eventList && data.eventList.length > 0) {
                data.eventList.forEach((element) => {
                    element.url = element.url === 'http://' ? '' : element.url;
                    if (element.featuredPostImage && element.featuredPostImage.url) {
                        element.featuredPostImage = {
                            ...element.featuredPostImage,
                            url: `${element.featuredPostImage.url}?${new Date().getTime().toString()}`,
                        };
                    }
                });
            }
        }

        state.featureEvents = data || null;
    },
    [storeMutation.updateFeatureEventAfterSave]: (state, data) => {
        const eventInState = state.featureEvents.eventList.find(item => item.id === data.id);
        if (eventInState) {
            data.featuredPostImage = data.featuredPostImage
                ? {
                      ...data.featuredPostImage,
                      url: data.featuredPostImage.url
                          ? `${data.featuredPostImage.url}?${new Date().getTime().toString()}`
                          : null,
                  }
                : null;
            state.featureEvents.eventList.splice(state.featureEvents.eventList.indexOf(eventInState), 1, data);
        } else {
            state.featureEvents.eventList.push(data);
        }
        prepareFeatureItemsForDragDrop(state.featureEvents);
    },
    [storeMutation.updateFeatureEventAfterDelete]: (state, featureEventId) => {
        const eventInState = state.featureEvents.eventList.find(item => item.id === featureEventId);
        if (eventInState) {
            state.featureEvents.eventList.splice(state.featureEvents.eventList.indexOf(eventInState), 1);
            prepareFeatureItemsForDragDrop(state.featureEvents);
        }
    },

    [storeMutation.updateFeatureEventInEdit]: (state, value) => {
        state.featureEventInEdit = value;
    },

    [storeMutation.editPost]: (state, postId) => {
        if (!state.postEdits[postId]) {
            state.postEdits = {
                ...state.postEdits,
                [postId]: true,
            };
        }
    },
    [storeMutation.handleUnHidePost]: (state, data) => {
        state.hiddenPostList[data.postId] = false;
        if (data.updateCommentCount) {
            state.activityFeedList.forEach((activity) => {
                if (activity.featuredComments.some(comment => comment.id === data.postId)) {
                    activity.commentCount += 1;
                }
            });
        }
    },
    [storeMutation.updatePostAfterRemovingMention]: (state, newPost) => {
        const index = state.activityFeedList.findIndex(o => o.id === newPost.id);
        state.activityFeedList[index].body = newPost.body;
        state.activityFeedList[index].mentions = newPost.mentions;

        // newPost = { ...newPost };
        // state.activityFeedList = state.activityFeedList.map((activity) => {
        //     if (activity.id === newPost.id) return { ...newPost };
        // });
    },
    [storeMutation.updatePostLocally]: (state, newPost) => {
        // TEMPORARY: newPost.canEdit is not being returned accurately from the API after update, so this overrides the value for now.
        // The assumption is that if the user just finished editing, they should be able to do it again just fine.
        newPost = { ...newPost, canEdit: true };

        state.activityFeedList = state.activityFeedList.map((activity) => {
            if (activity.id === newPost.id) return { ...newPost };

            activity.featuredComments = activity.featuredComments.map((comment) => {
                if (comment.id === newPost.parentPostId) {
                    comment.featuredComments = comment.featuredComments.map((reply) => {
                        return reply.id === newPost.id ? newPost : reply;
                    });
                }
                return comment.id === newPost.id ? newPost : comment;
            });
            return activity;
        });
    },

    [storeMutation.updateUnlikesLocally]: (state, postId) => {
        state.activityFeedList.forEach((activity) => {
            if (activity.id === postId && activity.userHasLiked) {
                activity.userHasLiked = false;
                activity.likeCount -= 1;
            }
            activity.featuredComments.forEach((comment) => {
                if (comment.id === postId && comment.userHasLiked) {
                    comment.userHasLiked = false;
                    comment.likeCount -= 1;
                }
                comment.featuredComments.forEach((reply) => {
                    if (reply.id === postId && reply.userHasLiked) {
                        reply.userHasLiked = false;
                        reply.likeCount -= 1;
                    }
                });
            });
        });
    },

    [storeMutation.inappropriatePostLocally]: (state, postId) => {
        state.activityFeedList = state.activityFeedList.filter((activity) => {
            if (activity.id === postId) return false;

            activity.featuredComments = activity.featuredComments.filter((comment) => {
                if (comment.id === postId && activity.commentCount > 0) {
                    activity.commentCount -= 1;
                    return false;
                }
                comment.featuredComments = comment.featuredComments.filter((reply) => {
                    if (reply.id === postId && comment.commentCount > 0) {
                        comment.commentCount -= 1;
                        return false;
                    }
                    return true;
                });
                return true;
            });
            return true;
        });
    },
    [storeMutation.addNewPostToList]: (state, post) => {
        if (post.isPendingModeration && !state.isCommunityAdmin) {
            return;
        }
        if (post.parentPostId) {
            state.activityFeedList.forEach((activity) => {
                if (activity.id === post.parentPostId) {
                    activity.featuredComments.unshift(post);
                    activity.userHasCommented = true;
                    activity.commentCount += 1;
                    return;
                }
                if (activity.featuredComments && activity.featuredComments.length) {
                    activity.featuredComments.forEach((comment) => {
                        if (comment.id === post.parentPostId) {
                            comment.featuredComments.unshift(post);
                            comment.commentCount += 1;
                        }
                    });
                }
            });
        } else if (state.activityFeedList && state.activityFeedList.length > 0) {
            state.activityFeedList.unshift(post);
        }
    },
    //TODO: (bishal) adding this method as placeholder - this feature is not yet available
    [storeMutation.removeShowMoreTriggeredPostFromState]: (state, postId) => {
        if (state.showMoreTriggeredPost.hasOwnProperty(postId)) {
            delete state.showMoreTriggeredPost[postId];
        }
    },
    [storeMutation.setProspectsList]: (state, prospectsList) => {
        state.prospectsList = prospectsList;
    },
    [storeMutation.createVote]: (state, data) => {
        state.votes = data;
    },
    [storeMutation.setusersCommunitiesListPromise]: (state, data) => {
        state.usersChaptersListPromise = data;
    },
    [storeMutation.setAboutView]: (state, data) => {
        if (data && data.aboutMessageImage && data.aboutMessageImage.url !== '') {
            data.aboutMessageImage.url += `?${Date.now()}`;
        }
        state.aboutView = data;
    },
    [storeMutation.setTransactionHubContent]: (state, data) => {
        state.transactionHubContent = data;
    },
    //chair Message
    [storeMutation.setChairMessage]: (state, data) => {
        if (data && data.chairMessageImage && data.chairMessageImage.url !== '') {
            data.chairMessageImage.url += `?${Date.now()}`;
            data.fallbackProfileImageUrl += `?${Date.now()}`;
            data.profileImageUrl += `?${Date.now()}`;
        }
        state.chairMessage = data;
    },
    //chapter Awards
    [storeMutation.setChapterAwards]: (state, data) => {
        state.chapterAwards = data;
    },
    //Region Chapter List

    [storeMutation.setChapterList]: (state, data) => {
        state.chapterList = data;
    },
    [storeMutation.setAllChapterList]: (state, data) => {
        state.allChapterList = data;
    },
    //End

    //Commented Users list
    [storeMutation.setCommentedUsers]: (state, data) => {
        state.commentedUsers = data;
    },
    //end
    //Liked Users list
    [storeMutation.setLikedUsers]: (state, data) => {
        state.likedUsers = data;
    },
    //end

    [storeMutation.closePostEditor]: (state, postId) => {
        state.postEdits[postId] = false;
    },
    [storeMutation.setPostChangePending]: (state, { postId, value }) => {
        state.postChangesPending = {
            ...state.postChangesPending,
            [postId]: value,
        };
    },
    [storeMutation.handleHiddenPost]: (state, data) => {
        state.hiddenPostList = {
            ...state.hiddenPostList,
            [data.postId]: true,
        };
        if (data.updateCommentCount) {
            state.activityFeedList.forEach((activity) => {
                if (activity.featuredComments.some(comment => comment.id === data.postId)) {
                    activity.commentCount -= 1;
                }
            });
        }
    },

    [storeMutation.deletePostLocally]: (state, postId) => {
        state.activityFeedList = state.activityFeedList.filter((activity) => {
            if (activity.id === postId) return false;

            activity.featuredComments = activity.featuredComments.filter((comment) => {
                comment.featuredComments = comment.featuredComments.filter((reply) => {
                    if (reply.id === postId) {
                        comment.commentCount -= 1;
                    }
                    return reply.id !== postId;
                });
                if (comment.id === postId) {
                    activity.commentCount -= 1;
                }
                return comment.id !== postId;
            });
            return true;
        });
    },
    [storeMutation.updateLikesLocally]: (state, postId) => {
        state.activityFeedList.forEach((activity) => {
            if (activity.id === postId && !activity.userHasLiked) {
                activity.userHasLiked = true;
                activity.likeCount += 1;
            }
            activity.featuredComments.forEach((comment) => {
                if (comment.id === postId && !comment.userHasLiked) {
                    comment.userHasLiked = true;
                    comment.likeCount += 1;
                }
                comment.featuredComments.forEach((reply) => {
                    if (reply.id === postId && !reply.userHasLiked) {
                        reply.userHasLiked = true;
                        reply.likeCount += 1;
                    }
                });
            });
        });
    },
    [storeMutation.setErrorFetchingCommunityData]: (state, errorStatus) => {
        state.errorFetchingCommunityData = errorStatus;
    },
    [storeMutation.setUserCommunityInfo]: (state, userData) => {
        state.communityInfo = userData;
        state.isCommunityAdmin = userData.isAdmin;
        state.chapterHealthScore = userData.health;
        state.communitySalesforceId = userData.salesforceId;
        state.isCommunityModerated = userData.isActivityModerated;
    },
    [storeMutation.confirmInappropriatePostLocally]: (state, userData) => {
        state.adminFeedList.forEach((post) => {
            if (userData.postType === 'post' && post.id === userData.postId) {
                post.hasBeenMarkedInappropriate = false;
                post.isConfirmedInappropriate = userData.isConfirmed;
                return;
            }
            if (
                post.featuredComments.some(comment => comment.id === userData.postId || comment.id === userData.parentPostId)
            ) {
                post.featuredComments.forEach((comment) => {
                    if (userData.postType === 'comment' && comment.id === userData.postId) {
                        comment.hasBeenMarkedInappropriate = false;
                        comment.isConfirmedInappropriate = userData.isConfirmed;
                        post.inappropriateChildren -= 1;
                        return;
                    }
                    if (userData.postType === 'reply' && comment.id === userData.parentPostId) {
                        comment.featuredComments.forEach((reply) => {
                            if (reply.id === userData.postId) {
                                reply.hasBeenMarkedInappropriate = false;
                                reply.isConfirmedInappropriate = userData.isConfirmed;
                                comment.inappropriateChildren -= 1;
                                post.inappropriateGrandChildren -= 1;
                                if (comment.inappropriateChildren === 0 && !comment.hasBeenMarkedInappropriate) {
                                    post.inappropriateChildren -= 1;
                                }
                        }
                        });
                    }
                });
            }
        });
    },
    [storeMutation.addShowMoreTriggeredPostToState]: (state, userData) => {
        const { postId, isAdminPageFeed } = userData;
        if (!state.showMoreTriggeredPost.hasOwnProperty(postId)) {
            (!isAdminPageFeed ? state.showMoreTriggeredPost : state.showMoreTriggeredPostForAdmin)[postId] = 1;
        } else {
            (!isAdminPageFeed ? state.showMoreTriggeredPost : state.showMoreTriggeredPostForAdmin)[postId] += 1;
        }
    },
    [storeMutation.updateParentPostWithShowMore]: (state, userData) => {
        const { postData, isAdminPageFeed } = userData;
        if (postData.parentPostId && postData.postList) {
            (isAdminPageFeed ? state.adminFeedList : state.activityFeedList).forEach((activity) => {
                if (activity.id === postData.parentPostId) {
                    activity.featuredComments = uniqBy([...activity.featuredComments, ...postData.postList], 'id');
                    activity.featuredComments = orderBy(activity.featuredComments, 'dateCreated', 'desc');
                    return;
                }
                if (activity.featuredComments && activity.featuredComments.length) {
                    activity.featuredComments.forEach((comment) => {
                        if (comment.id === postData.parentPostId) {
                            comment.featuredComments = uniqBy(
                                [...comment.featuredComments, ...postData.postList],
                                'id',
                            );
                        }
                        comment.featuredComments = orderBy(comment.featuredComments, 'dateCreated', 'desc');
                    });
                }
            });
        }
    },
    //TODO: (bishal) adding this method as placeholder - this feature is not yet available
    [storeMutation.updateParentPostWithShowLess]: (state, postId) => {
        if (postId) {
            state.activityFeedList.forEach((activity) => {
                if (activity.id === postId && activity.featuredComments.length > 2) {
                    activity.featuredComments.splice(0, activity.featuredComments.length - 2);
                    return;
                }
                if (activity.featuredComments && activity.featuredComments.length) {
                    activity.featuredComments.forEach((comment) => {
                        if (comment.id === postId && comment.featuredComments.length > 2) {
                            comment.featuredComments.splice(0, comment.featuredComments.length - 2);
                        }
                    });
                }
            });
        }
    },
    [storeMutation.setProspectsList]: (state, prospectsList) => {
        state.prospectsList = prospectsList;
    },
    [storeMutation.setVote]: (state, data) => {
        state.voted = data;
    },
    [storeMutation.sendLikeProspect]: (state, data) => {
        state.prospectsList.prospects.forEach((prospect) => {
            if (prospect.id === data.prospectId) {
                state.userHasVoted = prospect.userHasVoted;
                if (prospect.upCount != null && prospect.downCount != null) {
                    if (prospect.userHasVoted === 1 && data.vote === false) {
                        prospect.upCount -= prospect.upCount === 0 ? 0 : 1;
                        prospect.downCount += 1;
                    } else if (prospect.userHasVoted === 0 && data.vote === true) {
                        prospect.upCount += 1;
                        prospect.downCount -= prospect.downCount === 0 ? 0 : 1;
                    } else if (prospect.userHasVoted === -1 && data.vote === false) {
                        prospect.downCount += 1;
                    } else if (prospect.userHasVoted === -1 && data.vote === true) {
                        prospect.upCount += 1;
                    }
                } else {
                    prospect.upCount = null;
                    prospect.downCount = null;
                }

                prospect.userHasVoted = data.vote === true ? 1 : 0;
            }
        });
    },
    [storeMutation.unSendLikeProspect]: (state, data) => {
        state.prospectsList.prospects.forEach((prospect) => {
            if (prospect.id === data.prospectId) {
                if (state.userHasVoted !== -1) {
                    if (prospect.upCount != null && prospect.downCount != null) {
                        if (state.userHasVoted === 1 && data.vote === false) {
                            prospect.downCount -= prospect.downCount === 0 ? 0 : 1;
                            prospect.upCount += 1;
                        } else if (state.userHasVoted === 0 && data.vote === true) {
                            prospect.downCount += 1;
                            prospect.upCount -= prospect.upCount === 0 ? 0 : 1;
                        }
                    } else {
                        prospect.upCount = null;
                        prospect.downCount = null;
                    }
                    prospect.userHasVoted = data.vote === true ? 0 : 1;
                } else {
                    prospect.userHasVoted = -1;
                    prospect.upCount = prospect.upCount != null ? 0 : null;
                    prospect.downCount = prospect.downCount != null ? 0 : null;
                }
            }
        });
    },
    [storeMutation.setChapterOfficersData]: (state, data) => {
        state.chapterOfficersData = data;
    },
    [storeMutation.setUpcomingEventList]: (state, data) => {
        state.upcomingEventList = data;
        state.upcomingEventList.numberOfEvents = state.upcomingEventList.length;
        state.upcomingEventList.yearsMonths = makeYearMonthDate(data);
    },
    [storeMutation.updateSaveUpcomingEvents]: (state, upcomingEvent) => {
        state.upcomingEventList.forEach((event) => {
            if (event.id === upcomingEvent.id) {
                event.isSaved = upcomingEvent.isSaved;
                return true;
            }
        });
    },
    [storeMutation.updateRejectUpcomingEvents]: (state, upcomingEvent) => {
        state.upcomingEventList.forEach((event) => {
            if (event.id === upcomingEvent.id) {
                event.isDeclined = upcomingEvent.isDeclined;
                return true;
            }
        });
    },
    [storeMutation.NonMemberErrorMessage]: (state, errorInfo) => {
        if (
            errorInfo &&
            errorInfo.communityTypeName &&
            errorInfo.communityTypeName.toLowerCase() === 'forum' &&
            errorInfo.status === 403
        ) {
            state.NonMemberErrorMessage = communityCommonConstant.post.FORUM_NONMEMBER_MESSAGE;
        } else if (
            errorInfo &&
            errorInfo.communityTypeName &&
            (errorInfo.communityTypeName.toLowerCase() === 'network' ||
                errorInfo.communityTypeName.toLowerCase() === 'region' ||
                errorInfo.communityTypeName.toLowerCase() === 'group' ||
                errorInfo.communityTypeName.toLowerCase() === 'chapter') &&
            errorInfo.status === 403
        ) {
            state.NonMemberErrorMessage =
                communityCommonConstant.ActivityFeed.ALL_COMMUNITY_NON_MEMBER_MESSAGE + errorInfo.communityTypeName;
        } else {
            state.NonMemberErrorMessage = null;
        }
    },
    [storeMutation.setIsPMTeamMember]: (state, data) => {
        state.isPMTeamMember = data;
    },
    [storeMutation.setBusinessCommunityId]: (state, data) => {
        state.businessCommunityId = data;
    },
    [storeMutation.setUnRegisteredEvents]: (state, data) => {
        state.unRegisteredEvents = data;
    },
    [storeMutation.hideMainActivityFeed]: (state, data) => {
        state.isMainActivityFeedHidden = data;
    },
};

const chapterPageActions = {
    ...fileDragDropActions,
    ...filesAndMediaActions,
    ...chapterAdminDetailsActions,
    [storeAction.downloadPostAttachment]: ({ state }, data) => {
        return axios({
            url: `${state.baseURL}posts/api/post/postFileDownload`,
            headers: getBasicHeaders(),
            data,
            method: 'POST',
            responseType: 'arraybuffer',
        })
            .then((response) => {
                const blob = new Blob([response.data], { type: 'octet/stream' });
                FileSaver.saveAs(blob, `${data.FileName}`);
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getLikedUsers]: ({ state, commit }, postId) => {
        return axios({
            url: `${state.baseURL}posts/api/posts/likers/${postId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setLikedUsers, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },

    [storeAction.getChapterQuickLinks]: ({ state, commit }, communityId) => {
        return axios({
            url: `${state.baseURL}communities/api/communities/getChapterQuickLinks/${communityId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        }).then((response) => {
            commit(storeMutation.setChapterQuickLinks, response.data);
            return response.data;
        });
    },

    [storeAction.createChapterQuickLinks]: async ({ state, commit, rootGetters }, objectToSave) => {
        const communityId = await rootGetters[storeGetters.communityIdPromise];
        const objectToSubmit = {
            ...objectToSave,
            communityId,
        };
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}communities/api/communities/saveChapterQuickLinks`,
                headers: getBasicHeaders(),
                data: objectToSubmit,
                method: 'POST',
            })
                .then((response) => {
                    commit(storeMutation.setChapterQuickLinks, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    console.log(err);
                    reject(err);
                });
        });
    },

    [storeAction.modifyDisplayOrderChapterQuickLinks]: wrapAction(storeAction.modifyDisplayOrderNetworkCategories, ({ state, commit }, requestBody) => {
        const requestData = requestBody ;
        return axios({
            url: `${state.baseURL}communities/api/communities/saveChapterQuickLinksDisplayOrder`,
            headers: getBasicHeaders(),
            data: requestData,
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.setChapterQuickLinks, response.data);
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                throw err.response.data;
            });
    }),

    [storeAction.saveReorderedFeatureEvent]: wrapAction(
        storeAction.reorderFeatureEvent,
        ({ state, commit, rootGetters }) => {
            const communityTypeName = rootGetters[storeGetters.communityName];
            return rootGetters[storeGetters.communityIdPromise]
                .then((communityId) => {
                    return axios({
                        url: `${
                            state.baseURL
                        }posts/api/featuredPostsReorderList/${communityId}/${communityTypeName}`,
                        headers: getBasicHeaders(),
                        data: state.featureEvents.eventList,
                        method: 'PUT',
                    });
                })
                .then((response) => {
                    commit(storeMutation.updateFeatureEvents, response.data);
                    return response;
                })
                .catch((errResponse) => {
                    console.error('Error! (featuredPostsReorderList)', errResponse);
                    throw errResponse;
                });
        },
    ),
    [storeAction.deleteFeatureEvent]: wrapAction(
        storeAction.deleteFeatureEvent,
        ({ state, commit }, featureEventId) => {
            try {
                const response = axios({
                    url: `${state.baseURL}posts/api/featuredPost/${featureEventId}/chapter`,
                    headers: getBasicHeaders(),
                    method: 'DELETE',
                });
                commit(storeMutation.updateFeatureEventAfterDelete, featureEventId);
                return response;
            } catch (err) {
                console.log(err);
                throw err;
            }
        },
    ),
    [storeAction.sendRemoveMention]: ({ state, commit }, postId) => {
        axios({
            url: `${state.baseURL}posts/api/post/removeMention/${postId}`,
            headers: getBasicHeaders(),
            method: 'PUT',
        })
            .then(response => commit(storeMutation.updatePostAfterRemovingMention, response.data))
            .then(() => commit(storeMutation.closePostEditor, postId))
            .catch(errResponse => console.error('whoops! (submitRemoveMention)', errResponse));
    },
    [storeAction.getChapterOfficersData]: wrapAction(storeAction.getChapterOfficersData, ({ commit, rootGetters, state }) => {
        const communityTypeName = rootGetters[storeGetters.communityName];
        return rootGetters[storeGetters.communityIdPromise]
            .then((communityId) => {
                if (!communityId) return null;
                const requestSource = getAxiosCancelTokenSource();
                const requestObject = {
                    actionName: storeAction.getChapterOfficersData,
                    requestSource,
                };
                commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

                return axios({
                    url: `${
                        state.baseURL
                    }communities/api/chapterAdminOfficersList/${communityId}/${communityTypeName}`,
                    headers: getBasicHeaders(),
                    cancelToken: requestSource.token,
                });
            })
            .then((response) => {
                if (!response) return;
                commit(storeMutation.removeCancelableRequest, storeAction.getChapterOfficersData, { root: true });
                commit(storeMutation.setChapterOfficersData, response.data);
            })
            .catch(() => {
                commit(storeMutation.setChapterOfficersData, []);
            });
    }),
    [storeAction.getusersCommunitiesList]: wrapAction(
        storeAction.getusersCommunitiesList,
        ({ commit, state }) => {
            const requestSource = getAxiosCancelTokenSource();
            const requestObject = {
                actionName: storeAction.getusersCommunitiesList,
                requestSource,
            };
            commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

            const promise = axios({
                // url: '/mocks/listCommunitiesByUser.json',
                url: `${state.baseURL}communities/api/community/listCommunitiesByUser`,
                headers: getBasicHeaders(),
                method: 'GET',
                cancelToken: requestSource.token,
            }).then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.getusersCommunitiesList, { root: true });
                commit(storeMutation.setusersCommunitiesList, response.data);
                return response;
            });

            commit(storeMutation.setusersCommunitiesListPromise, promise);

            return promise;
        },
    ),
    [storeAction.getCommunityById]: ({ state, commit, rootGetters }, communityIdToUse) => {
        commit(storeMutation.setErrorFetchingCommunityData, false);
        return rootGetters[storeGetters.communityIdPromise]
            .then((communityId) => {
                if (
                    !communityIdToUse &&
                    state.usersCommunitiesList &&
                    state.usersCommunitiesList.some(o => o.communityId === communityId)
                ) {
                    return new Promise((resolve) => {
                        resolve({ data: state.usersCommunitiesList.find(o => o.communityId === communityId) });
                    });
                }

                if (communityIdToUse || (communityId && communityId !== communityCommonConstant.EMPTY_GUID)) {
                    const requestSource = getAxiosCancelTokenSource();
                    const requestObject = {
                        actionName: storeAction.getCommunityById,
                        requestSource,
                    };
                    commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

                    return axios({
                        url: `${state.baseURL}communities/api/getCommunity/${communityIdToUse ||
                            communityId}`,
                        headers: getBasicHeaders(),
                        method: 'GET',
                        cancelToken: requestSource.token,
                    });
                }
                return false;
            })
            .then((response) => {
                if (!response) {
                    commit(storeMutation.setErrorFetchingCommunityData, true);
                    return;
                }
                commit(storeMutation.removeCancelableRequest, storeAction.getCommunityById, { root: true });
                commit(storeMutation.setUserCommunityInfo, response.data);
                commit(storeMutation.setErrorFetchingCommunityData, false);
                return response;
            })
            .catch((err) => {
                if (err && err.message && !err.message.toLowerCase().includes("request canceled")) {
                    commit(storeMutation.setErrorFetchingCommunityData, true);
           }
     });
},
    [storeAction.getCommunityByName]: ({ state, commit }, data = {}) => {
        const { communityType, communityName } = data;
        if (communityType && communityName) {
            state.communityInfoByNamePromise = new Promise((resolve) => {
                if (
                    state.communityInfo &&
                    state.communityInfo.name === communityName &&
                    state.communityInfo.communityType === communityType
                ) {
                    commit(storeMutation.setUserCommunityInfo, state.communityInfo);
                    return resolve(state.communityInfo);
                } else if (
                    state.usersCommunitiesList &&
                    state.usersCommunitiesList.some(o =>
                            o.name.trim().toLowerCase() === communityName.trim().toLowerCase() &&
                            o.communityType.trim().toLowerCase() === communityType.trim().toLowerCase())
                ) {
                    const communityInfo = state.usersCommunitiesList.find(o =>
                            o.name.trim().toLowerCase() === communityName.trim().toLowerCase() &&
                            o.communityType.trim().toLowerCase() === communityType.trim().toLowerCase());
                    commit(storeMutation.setUserCommunityInfo, communityInfo);
                    return resolve(communityInfo);
                }
                const requestSource = getAxiosCancelTokenSource();
                const requestObject = {
                    actionName: storeAction.getCommunityById,
                    requestSource,
                };
                commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

                return axios({
                    url: `${
                        state.baseURL
                    }communities/api/getCommunityByName/${communityName}/${communityType}`,
                    headers: getBasicHeaders(),
                    method: 'GET',
                    cancelToken: requestSource.token,
                })
                    .then((response) => {
                        commit(storeMutation.setUserCommunityInfo, response.data);
                        resolve(response.data);
                    })
                    .finally(() => {
                        commit(storeMutation.removeCancelableRequest, storeAction.getCommunityById, { root: true });
                    });
            });
            return state.communityInfoByNamePromise;
        }
    },
    // [storeAction.getParentCommunityById]: ({ state, commit }, communityId) => {
    //     axios({
    //         url: `${state.baseURL}communities/api/getCommunity/${communityId}`,
    //         headers: getBasicHeaders(),
    //         method: 'Get',
    //     })
    //         .then(response => commit(storeMutation.parentCommunity, response.data))
    //         .catch(errResponse => console.error('whoops! (submitRemoveMention)', errResponse));
    // },
    [storeAction.getMentionsList]: ({ state, rootGetters }, search) => {
        const communityTypeName = rootGetters[storeGetters.communityName];
        return rootGetters[storeGetters.communityIdPromise]
            .then(communityId =>
                axios({
                    url: `${
                        state.baseURL
                    }profiles/api/membersearch/${communityId}/${communityTypeName}/${search}`,
                    headers: getBasicHeaders(),
                }))
            .then((response) => {
                return response;
            });
    },
    [storeAction.getChapterActivityList]: wrapAction(
        storeAction.getChapterActivityList,
        ({ state, commit, rootGetters }, post) => {
            let requestName;
            const communityTypeName = rootGetters[storeGetters.communityName];
            const pageNumber = state.nextActivityFeedListPageNumber;
            const pageSize = post && post.postId ? 1 : communityCommonConstant.post.searchResultOffsetStep;
            const postId = post && post.postId ? post.postId : '';
            const highlightText = post && post.highlightText ? post.highlightText : '';
            const showAllActivityFeedCommunity =
                post && post.showAllActivityFeedCommunity ? post.showAllActivityFeedCommunity : 'false';
            return rootGetters[storeGetters.communityIdPromise]
                .then((communityId) => {
                    let newUrl;
                    const requestSource = getAxiosCancelTokenSource();
                    if (communityTypeName.toLowerCase() === 'home') {
                        newUrl = `${
                            state.baseURL
                        }posts/api/post/getFollowedPostsList?skipNumber=${
                            state.nextHomePageSkip
                        }&takeSize=${pageSize}&highlightText=${highlightText}&showAllActivityFeedCommunity=${showAllActivityFeedCommunity}`;
                        requestName = `${storeAction.getChapterActivityList}_${communityId}_skipNumber=${state.nextHomePageSkip}`;
                    } else {
                        newUrl = `${
                            state.baseURL
                        }posts/api/post/list/by-community/${communityId}/${communityTypeName}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
                        requestName = `${storeAction.getChapterActivityList}_${communityId}_pageNumber=${pageNumber}`;
                    }
                    newUrl = postId
                        ? `${
                              state.baseURL
                          }posts/api/post/get-post-all-activity-feed/${postId}?highlightText=${highlightText}`
                        : newUrl;
                    if (!state.noMoreActivityToFetch) {
                        commit(storeMutation.setInfiniteScrollState, true);
                        if (requestName) {
                            const requestObject = {
                                communityId,
                                requestName,
                                actionName: storeAction.getChapterActivityList,
                                requestSource,
                            };
                            commit(storeMutation.handleActivityFeedCancelableRequest, requestObject, { root: true });
                        }
                        return axios({
                            //mock for local testing
                            //url: '/mocks/chapterActivityList.json',
                            url: newUrl,
                            headers: getBasicHeaders(),
                            method: 'GET',
                            cancelToken: requestSource.token,
                        });
                    }
                })
                .then((response) => {
                    if (response && response.data) {
                        if (
                            !response.data.length ||
                            response.data.length < pageSize ||
                            response.data.id != null ||
                            postId
                        ) {
                            state.noMoreActivityToFetch = true;
                        }
                        const posts = response.data && response.data.id != null ? [response.data] : response.data;
                        commit(storeMutation.setChapterActivityList, posts);
                        const errorInfo = { communityTypeName, status: response.status };
                        if (requestName) {
                            commit(storeMutation.removeActivityFeedCancelableRequest, requestName, { root: true });
                        }
                    }
                    commit(storeMutation.setInfiniteScrollState, false);
                })
                .catch((err) => {
                    //TODO: handle error
                    if (!axios.isCancel(err)) {
                        const errorInfo = { communityTypeName, status: err && err.response && err.response.status };
                        commit(storeMutation.setChapterActivityList, []);
                        commit(storeMutation.setInfiniteScrollState, false);
                        console.log(err);
                    }
                });
        },
    ),
    [storeAction.getAdminFeedList]: wrapAction(storeAction.getAdminFeedList, ({ state, commit, rootGetters }) => {
        return rootGetters[storeGetters.communityIdPromise]
            .then((communityId) => {
                if (!communityId || communityId === communityCommonConstant.EMPTY_GUID) return null;
                return axios({
                    //url: '/mocks/chapterInappropriateActivityList.json',
                    url: `${
                        state.baseURL
                    }posts/api/post/inappropriate-list/by-community/${communityId}`,
                    headers: getBasicHeaders(),
                    method: 'GET',
                });
            })
            .then((response) => {
                if (!response) return;
                commit(storeMutation.setAdminFeedList, response.data);
            })
            .catch((err) => {
                //TODO: handle error
                commit(storeMutation.setAdminFeedList, null);
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getChairMessage]: ({ state, commit, rootGetters }) => {
        const communityTypeName = rootGetters[storeGetters.communityName];
        return rootGetters[storeGetters.communityIdPromise]
            .then((communityId) => {
                if (!communityId) return null;
                const requestSource = getAxiosCancelTokenSource();
                const requestObject = {
                    actionName: storeAction.getChairMessage,
                    requestSource,
                };
                commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

                return axios({
                    url: `${
                        state.baseURL
                    }communities/api/communities/${communityId}/chair-messages/${communityTypeName}`,
                    headers: getBasicHeaders(),
                    method: 'GET',
                    cancelToken: requestSource.token,
                });
            })
            .then((response) => {
                if (response) commit(storeMutation.setChairMessage, response.data);
                commit(storeMutation.removeCancelableRequest, storeAction.getChairMessage, { root: true });
                return response;
            })
            .catch((err) => {
                //TODO: handle error
                commit(storeMutation.setChairMessage, null);
                console.log(err);
                throw err;
            });
    },
    [storeAction.createActivityPost]: wrapAction(
        storeAction.createActivityPost,
        ({ state, commit, rootGetters }, objectToSave) => {
            return axios({
                url: `${state.baseURL}posts/api/post/create/${
                    rootGetters[storeGetters.communityName]
                }`, //Deployed url
                headers: getBasicHeaders(),
                data: { ...objectToSave },
                method: 'POST',
            })
                .then((response) => {
                    commit(storeMutation.addNewPostToList, response.data);
                    const isModeratedPost = response.data.isPendingModeration;
                    commit(storeMutation.setModeratedPostCreated, isModeratedPost);
                    return response.data;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.uploadFilesToTemporaryStorage]: wrapAction(
        storeAction.uploadFilesToTemporaryStorage,
        ({ state, rootGetters }, postData) => {
            return rootGetters[storeGetters.communityIdPromise]
                .then((communityId) => {
                    const validatedCommunityId =
                        state.usersCommunitiesList.some(o => o.communityId === communityId && o.name.toLowerCase() === myToolsConstants.YOUR_NETWORKS_CONSOLIDATED_LOWER_CASE) && postData.selectedNetworkId
                            ? postData.selectedNetworkId
                            : communityId;
                    return axios({
                        url: `${state.baseURL}uploads/api/upload/${validatedCommunityId}/${
                            rootGetters[storeGetters.communityName]
                        }`,
                        headers: getHeadersWithFormData(),
                        data: postData.selectedFiles,
                        method: 'POST',
                    });
                })
                .then((response) => {
                    return response.data;
                })
                .catch((err) => {
                    console.error('whoops! (submitPostEdit)', err);
                    throw err;
                });
        },
    ),

    [storeAction.submitPostEdit]: wrapAction(storeAction.submitPostEdit, ({ state, commit, getters }, post) => {
        const postId = post.id;
        const changePending = getters[storeGetters.isPostChangePending](postId);
        if (changePending) return;

        const setPending = value => commit(storeMutation.setPostChangePending, { postId, value });

        setPending(true);
        return axios({
            url: `${state.baseURL}posts/api/post/update/${postId}`,
            headers: getBasicHeaders(),
            data: post,
            method: 'PUT',
        })
            .then(response => commit(storeMutation.updatePostLocally, response.data))
            .then(() => commit(storeMutation.closePostEditor, postId))
            .catch(errResponse => console.error('whoops! (submitPostEdit)', errResponse)) // TODO: report this
            .finally(() => setPending(false));
    }),
    [storeAction.sendDeletePost]: ({ state, commit, getters }, postId) => {
        const changePending = getters[storeGetters.isPostChangePending](postId);
        if (changePending) return;

        const setPending = value => commit(storeMutation.setPostChangePending, { postId, value });

        setPending(true);
        axios({
            url: `${state.baseURL}posts/api/post/delete/${postId}`,
            headers: getBasicHeaders(),
            method: 'DELETE',
        })
            .then(() => commit(storeMutation.deletePostLocally, postId))
            .catch(errResponse => console.error('whoops! (sendDeletePost)', errResponse)) // TODO: report this
            .finally(() => setPending(false));
    },
    [storeAction.sendInappropriatePost]: ({ state, commit, rootGetters }, { postId, communityTypeName }) => {
        if (postId == null || postId === '00000000-0000-0000-0000-000000000000') {
            return;
        }

        if (!communityTypeName) {
            communityTypeName = rootGetters[storeGetters.communityName];
        }

        axios({
            url: `${state.baseURL}posts/api/post/inappropriate/${postId}/${communityTypeName}`,
            headers: getBasicHeaders(),
            method: 'POST',
        })
            .then(() => commit(storeMutation.inappropriatePostLocally, postId))
            .catch(errResponse => console.error('Error! (sendInappropriatePost)', errResponse));
    },
    [storeAction.sendConfirmationInappropriatePost]: ({ state, commit, rootGetters }, user) => {
        const { postId, isConfirmed } = user;
        return rootGetters[storeGetters.communityIdPromise]
            .then((communityId) => {
                return axios({
                    url: `${
                        state.baseURL
                    }posts/api/post/markInappropriateReportsAsReviewed/${communityId}/${postId}/${isConfirmed}`,
                    headers: getBasicHeaders(),
                    method: 'PUT',
                });
            })
            .then(() => {
                //TODO: (bishal + sam) - need to refactor this - for now just do a GET
                commit(storeMutation.confirmInappropriatePostLocally, user);
               // dispatch(storeAction.getAdminFeedList);
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },

    [storeAction.hidePost]: ({ state, commit }, postId) => {
        commit(storeMutation.handleHiddenPost, { postId });
        axios({
            url: `${state.baseURL}posts/api/post/hide/${postId}`,
            headers: getBasicHeaders(),
            method: 'POST',
        })
            .then(() => {
                commit(storeMutation.handleHiddenPost, { postId, updateCommentCount: true });
            })
            .catch(errResponse => console.error('Error! (hidePost)', errResponse));
    },
    [storeAction.unHidePost]: ({ state, commit }, postId) => {
        commit(storeMutation.handleUnHidePost, { postId });
        axios({
            url: `${state.baseURL}posts/api/post/unhide/${postId}`,
            headers: getBasicHeaders(),
            method: 'POST',
        })
            .then(() => {
                commit(storeMutation.handleUnHidePost, { postId, updateCommentCount: true });
            })
            .catch(errResponse => console.error('Error! (hidePost)', errResponse));
    },
    [storeAction.sendLike]: ({ state, commit, rootGetters }, postId) => {
        axios({
            url: `${state.baseURL}posts/api/like/create/${postId}/${
                rootGetters[storeGetters.communityName]
            }`,
            headers: getBasicHeaders(),
            method: 'POST',
        })
            .then(() => {
                console.log('Like API Called');
                commit(storeMutation.updateLikesLocally, postId);
            })
            .catch((err) => {
                console.error('Error! (sendLike)', err);
                commit(storeMutation.updateUnlikesLocally, postId);
            });
    },
    [storeAction.sendUnlike]: ({ state, commit }, postId) => {
        axios({
            url: `${state.baseURL}posts/api/like/${postId}`,
            headers: getBasicHeaders(),
            method: 'DELETE',
        })
            .then(() => {
                console.log('UnLike API Called');
                commit(storeMutation.updateUnlikesLocally, postId);
            })
            .catch((err) => {
                console.error('Error! (sendUnLike)', err);
                commit(storeMutation.updateLikesLocally, postId);
            });
    },
    [storeAction.getMoreCommentsForPost]: ({
state, commit, getters, rootGetters,
}, PostObj) => {
        const pageCount = getters[storeGetters.getShowMoreCallCountForPost](PostObj);
        const { postId, isAdminPageFeed } = PostObj;
        const changePending = getters[storeGetters.isPostChangePending](postId);
        if (changePending) return;

        const setPending = value => commit(storeMutation.setPostChangePending, { postId, value });
        const commentType = isAdminPageFeed ? 'inappropriate/' : '';

        setPending(true);
        axios({
            url: `${
                state.baseURL
            }posts/api/post/list/by-comments/${commentType}${postId}/${pageCount}/${
                rootGetters[storeGetters.communityName]
            }`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                const postData = {
                    parentPostId: postId,
                    postList: response.data.comments,
                };
                commit(storeMutation.updateParentPostWithShowMore, { postData, isAdminPageFeed });
                if (response.data.showMore) {
                    commit(storeMutation.addShowMoreTriggeredPostToState, { postId, isAdminPageFeed });
                }
            })
            .catch((err) => {
                //TODO: handle error
                console.log(err);
            })
            .finally(() => setPending(false));
    },
    [storeAction.createChairMessage]: wrapAction(
        storeAction.createChairMessage,
        ({ state, commit, rootGetters }, objectToSave) => {
            return axios({
                url: `${state.baseURL}communities/api/communities/chair-messages/${
                    rootGetters[storeGetters.communityName]
                }`,
                headers: getBasicHeaders(),
                data: { ...objectToSave },
                method: 'POST',
            })
                .then((response) => {
                    commit(storeMutation.setChairMessage, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    //Get chapter Awards
    [storeAction.getChapterAwards]: ({ commit, rootGetters, state }, champsCommunityId) => {
        const communityIdPromise = champsCommunityId
            ? Promise.resolve(champsCommunityId)
            : rootGetters[storeGetters.communityIdPromise];
        return communityIdPromise
            .then((communityId) => {
                const requestSource = getAxiosCancelTokenSource();
                const requestObject = {
                    actionName: storeAction.getChapterAwards,
                    requestSource,
                };
                commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

                return axios({
                    //mock for local testing
                    //TODO: replace the hard-coded community ID later
                    url: `${
                        state.baseURL
                    }communities/api/awards/list/by-community/${communityId}/${
                        rootGetters[storeGetters.communityName]
                    }`,
                    headers: getBasicHeaders(),
                    method: 'GET',
                    cancelToken: requestSource.token,
                });
            })
            .then((response) => {
                commit(storeMutation.setChapterAwards, response.data);
                commit(storeMutation.removeCancelableRequest, storeAction.getChapterAwards, { root: true });
                return response;
            })
            .catch((err) => {
                //TODO: handle error
                console.log(err);
                throw err;
            });
    },
    //Get Region ChapterList
    [storeAction.getChapterList]: ({ state, commit, rootGetters }, parentId) => {
        const communityIdPromise = parentId ? Promise.resolve(parentId) : rootGetters[storeGetters.communityIdPromise];

        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getChapterList,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

        return communityIdPromise
            .then((communityId) => {
                return axios({
                    url: `${state.baseURL}communities/api/communities/communitiesByRegion/${communityId}`,
                    headers: getBasicHeaders(),
                    method: 'GET',
                    cancelToken: requestSource.token,
                });
            })
            .then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.getChapterList, { root: true });
                commit(storeMutation.setChapterList, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getAllChapterList]: ({ state, commit }) => {
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getAllChapterList,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

        return axios({
            //mock for local testing
            // url: '/mocks/ChapterList.json',
            //TODO: replace the hard-coded community ID later
            url: `${state.baseURL}communities/api/communities/get-all-chapters`,
            headers: getBasicHeaders(),
            method: 'GET',
            cancelToken: requestSource.token,
        })
            .then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.getAllChapterList, { root: true });
                commit(storeMutation.setAllChapterList, response.data);
                return response;
            })
            .catch((err) => {
                //TODO: handle error
                console.log(err);
                throw err;
            });
    },
    [storeAction.getChapterMessage]: ({ state, commit }, communityId ) => {
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getChapterMessage,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

        return axios({
            url: `${state.baseURL}communities/api/communities/getChapterWelcomeMessage/${communityId}`,
            headers: getBasicHeaders(),
            method: 'GET',
            cancelToken: requestSource.token,
        })
            .then((response) => {
                commit(storeMutation.setChapterMessage, response.data);
                commit(storeMutation.removeCancelableRequest, storeAction.getChapterMessage, { root: true });
                return response;
            })
            .catch((err) => {
                commit(storeMutation.setChapterMessage, null);
                console.log(err);
                throw err;
            });
    },

    [storeAction.createChapterMessage]: wrapAction(
        storeAction.createChapterMessage,
        ({ state, commit, rootGetters }, formData) => {
            return axios({
                url: `${state.baseURL}communities/api/communities/saveChapterWelcomeMessage`,
                headers: getHeadersWithFormData(),
                data: formData,
                method: 'POST',
            })
                .then((response) => {
                    commit(storeMutation.setChapterMessage, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    //end

    [storeAction.getAboutView]: async ({
 state, commit, dispatch, rootGetters,
}, chapterCommunityId) => {
        let communityTypeName = rootGetters[storeGetters.communityName];
        if (chapterCommunityId === undefined) {
            chapterCommunityId = await rootGetters[storeGetters.communityIdPromise];
        }
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getAboutView,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

        if (communityTypeName.toLowerCase() === routerNames.BUSINESSES.toLowerCase()) {
            if (state.businessCommunityId == null) {
                await dispatch(storeAction.getBusinessCommunityId);
            }
            communityTypeName = 'businesses';
            chapterCommunityId = state.businessCommunityId;
        }
        return axios({
            url: `${
                state.baseURL
            }communities/api/communities/${chapterCommunityId}/community-about/${communityTypeName}`,
            headers: getBasicHeaders(),
            method: 'GET',
            cancelToken: requestSource.token,
        })
            .then((response) => {
                if (!response || response.data == null || response.data === []) {
                    commit(storeMutation.setAboutView, null);
                    return;
                }
                commit(storeMutation.setAboutView, response.data);
                commit(storeMutation.removeCancelableRequest, storeAction.getAboutView, { root: true });
                return response;
            })
            .catch((err) => {
                commit(storeMutation.setAboutView, null);
                console.log(err);
                throw err;
            });
    },

    [storeAction.getTransactionHubContent]: wrapAction(
        storeAction.getTransactionHubContent,
        ({ state, commit, rootGetters }) => {
            return rootGetters[storeGetters.communityIdPromise]
                .then((communityId) => {
                    communityId =  communityId ? communityId : communityCommonConstant.transactionHub.EMPTY_GUID;
                    const requestSource = getAxiosCancelTokenSource();
                    const requestObject = {
                        actionName: storeAction.getTransactionHubContent,
                        requestSource,
                    };
                    commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

                    return axios({
                        url: `${state.baseURL}communities/api/transactionhub/${communityId}`,
                        headers: getBasicHeaders(),
                        method: 'GET',
                        cancelToken: requestSource.token,
                    });
                })
                .then((response) => {
                    const content = (response && response.data) || { canEdit: true };
                    commit(storeMutation.removeCancelableRequest, storeAction.getTransactionHubContent, { root: true });
                    commit(storeMutation.setTransactionHubContent, content);
                    return response;
                })
                .catch((err) => {
                    commit(storeMutation.setTransactionHubContent, {});
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.saveTransactionHubContent]: wrapAction(
        storeAction.saveTransactionHubContent,
        ({ state, commit }, content) => {
            return axios({
                url: `${state.baseURL}communities/api/transactionhub/upsert`,
                headers: getBasicHeaders(),
                method: 'POST',
                data: content,
            })
                .then((response) => {
                    commit(storeMutation.setTransactionHubContent, response.data);
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),

    [storeAction.createUpdateAboutMessage]: ({ commit, state }, aboutDetails) => {
        const { communityTypeName, objectToSave, method } = aboutDetails;
        return axios({
            url: `${
                state.baseURL
            }communities/api/communities/community-about/${communityTypeName}`,
            headers: getBasicHeaders(),
            data: { ...objectToSave },
            method,
        })
            .then((response) => {
                commit(storeMutation.setAboutView, response.data);
                return response;
            })
            .catch((err) => {
                //TODO: handle error
                console.log(err);
                throw err;
            });
    },

    [storeAction.createAboutMessage]: wrapAction(
        storeAction.createAboutMessage,
        ({ dispatch, rootGetters }, objectToSave) => {
            let communityTypeName = rootGetters[storeGetters.communityName];
            if (communityTypeName.toLowerCase() === routerNames.BUSINESSES.toLowerCase()) {
                communityTypeName = 'businesses';
            }
            return dispatch(storeAction.createUpdateAboutMessage, { communityTypeName, objectToSave, method: 'POST' });
        },
    ),

    [storeAction.updateAboutMessage]: wrapAction(
        storeAction.updateAboutMessage,
        ({ dispatch, rootGetters }, objectToSave) => {
            const communityTypeName = rootGetters[storeGetters.communityName];
            return dispatch(storeAction.createUpdateAboutMessage, { communityTypeName, objectToSave, method: 'PUT' });
        },
    ),

    // Get Commented User list on Post
    [storeAction.getCommentedUsers]: ({ state, commit }, postId) => {
        return axios({
            url: `${state.baseURL}posts/api/post/listUsers/by-post/${postId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setCommentedUsers, response.data);
                return response;
            })
            .catch((err) => {
                //TODO: handle error
                console.log(err);
                throw err;
            });
    },

    //End
    [storeAction.getProspectsList]: ({ state, commit, rootGetters }) => {
        if (rootGetters[storeGetters.communityName] !== 'Chapter') {
            return;
        }
        return rootGetters[storeGetters.communityIdPromise]
            .then((communityId) => {
                return axios({
                    url: `${state.baseURL}communities/api/communities/${communityId}/prospects`,
                    headers: getBasicHeaders(),
                    method: 'GET',
                });
            })
            .then((response) => {
                commit(storeMutation.setProspectsList, response.data);
                return response;
            })
            .catch((err) => {
                commit(storeMutation.setProspectsList, null);
                console.log(err);
                throw err;
            });
    },
    [storeAction.ProspectsResultsDownload]: ({ state, rootGetters }) => {
        if (rootGetters[storeGetters.communityName] !== 'Chapter') {
            return;
        }
        state.prospectDownloadInProgress = true;
        return rootGetters[storeGetters.communityIdPromise]
            .then((communityId) => {
                return axios({
                    url: `${
                        state.baseURL
                    }communities/api/communities/${communityId}/prospectvoterreport`,
                    headers: getBasicHeaders(),
                    method: 'GET',
                    responseType: 'arraybuffer',
                });
            })
            .then((response) => {
                state.prospectDownloadInProgress = false;
                const blob = new Blob([response.data], { type: 'octet/stream' });
                FileSaver.saveAs(blob, `ProspectResult.xlsx`);
            })
            .catch((err) => {
                state.prospectDownloadInProgress = false;
                console.log(err);
                throw err;
            });
    },
    [storeAction.createVote]: ({ state, commit, rootGetters }, votes) => {
        commit(storeMutation.sendLikeProspect, votes);
        return rootGetters[storeGetters.communityIdPromise]
            .then((communityId) => {
                return axios({
                    url: `${state.baseURL}communities/api/community/${communityId}/vote/create/${
                        votes.prospectId
                    }/${votes.vote}`,
                    headers: getBasicHeaders(),
                    method: 'POST',
                });
            })
            .then((response) => {
                commit(storeMutation.setVote, response.data);
                return response;
            })
            .catch((err) => {
                commit(storeMutation.unSendLikeProspect, votes);
                console.log(err);
                throw err;
            });
    },
    [storeAction.getFeatureEvents]: wrapAction(storeAction.getFeatureEvents, async ({ state, commit, rootGetters }) => {
        commit(storeMutation.updateFeatureEvents, null);
        const communityTypeName = rootGetters[storeGetters.communityName];
        return rootGetters[storeGetters.communityIdPromise]
            .then((communityId) => {
                if (!communityId && communityTypeName.toLowerCase() === routerNames.NETWORK.toLowerCase()) {
                    communityId = 'my';
                }
                return axios({
                    url: `${
                        state.baseURL
                    }posts/api/featuredPost/list/by-community/${communityId}/${communityTypeName}`,
                    headers: getBasicHeaders(),
                    method: 'GET',
                });
            })
            .then((response) => {
                commit(storeMutation.updateFeatureEvents, response.data);
            })
            .catch((err) => {
                //TODO: handle error
                console.log(err);
            });
    }),

    [storeAction.createFeatureEvent]: wrapAction(
        storeAction.createFeatureEvent,
        ({ state, commit, rootGetters }, featureEvent) => {
            const [actionUrlSegment, method, communityTypeName] =
                featureEvent && featureEvent.id
                    ? ['update', 'PUT', rootGetters[storeGetters.communityName]]
                    : ['create', 'POST', rootGetters[storeGetters.communityName]];
            if (featureEvent.url && featureEvent.url.length) {
                featureEvent.url = normalizeUrl(featureEvent.url);
            }
            return rootGetters[storeGetters.communityIdPromise]
                .then((communityId) => {
                    return axios({
                        url: `${
                            state.baseURL
                        }posts/api/featuredPost/${actionUrlSegment}/by-community/${communityId}/${communityTypeName}`,
                        headers: getBasicHeaders(),
                        data: {
                            ...featureEvent,
                            communityId,
                        },
                        method,
                    });
                })
                .then((response) => {
                    commit(storeMutation.updateFeatureEventAfterSave, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.deleteFeatureEvent]: wrapAction(
        storeAction.deleteFeatureEvent,
        ({ state, commit, rootGetters }, featureEventId) => {
            const communityTypeName = rootGetters[storeGetters.communityName];
            return axios({
                url: `${
                    state.baseURL
                }posts/api/featuredPost/${featureEventId}/${communityTypeName}`,
                headers: getBasicHeaders(),
                method: 'DELETE',
            })
                .then((response) => {
                    commit(storeMutation.updateFeatureEventAfterDelete, featureEventId);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.sendRemoveMention]: ({ state, commit }, postId) => {
        axios({
            url: `${state.baseURL}posts/api/post/removeMention/${postId}`,
            headers: getBasicHeaders(),
            method: 'PUT',
        })
            .then(response => commit(storeMutation.updatePostLocally, response.data))
            .then(() => commit(storeMutation.closePostEditor, postId))
            .catch(errResponse => console.error('whoops! (submitRemoveMention)', errResponse));
    },
    [storeAction.getUpcomingEventList]: wrapAction(
        storeAction.getUpcomingEventList,
        ({ state, commit, rootGetters }, champsCommunityId) => {
            let communityIdPromise = Promise.resolve(champsCommunityId);
            let communityTypeName = 'chapter';
            if (!champsCommunityId) {
                communityIdPromise = rootGetters[storeGetters.communityIdPromise];
                communityTypeName = rootGetters[storeGetters.communityName];
            }
            return communityIdPromise
                .then((communityId) => {
                    const requestSource = getAxiosCancelTokenSource();
                    const requestObject = {
                        actionName: storeAction.getUpcomingEventList,
                        requestSource,
                    };
                    commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

                    if (
                        communityId &&
                        communityId !== communityCommonConstant.EMPTY_GUID &&
                        state.usersCommunitiesList &&
                        !state.usersCommunitiesList.some(o => o.communityId === communityId && o.name.toLowerCase() === myToolsConstants.YOUR_NETWORKS_CONSOLIDATED_LOWER_CASE)
                    ) {
                        return axios({
                            url: `${
                                state.baseURL
                            }events/api/events/get/${communityId}/${communityTypeName}`,
                            headers: getBasicHeaders(),
                            method: 'GET',
                            cancelToken: requestSource.token,
                        });
                    }
                    return axios({
                        url: `${
                            state.baseURL
                        }events/api/events/ByCommunityType/${communityTypeName}`,
                        headers: getBasicHeaders(),
                        method: 'GET',
                        cancelToken: requestSource.token,
                    });
                })
                .then((response) => {
                    commit(storeMutation.removeCancelableRequest, storeAction.getUpcomingEventList, { root: true });
                    commit(storeMutation.setUpcomingEventList, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.getUpcomingEventListForCAView]: wrapAction(
        storeAction.getUpcomingEventListForCAView,
        ({ state, commit, rootGetters }) => {
            return rootGetters[storeGetters.communityIdPromise]
                .then((communityId) => {
                    return axios({
                        url: `${
                            state.baseURL
                        }events/api/events/get-chapterAdmin-eventsList/${communityId}`,
                        headers: getBasicHeaders(),
                        method: 'GET',
                    });
                })
                .then((response) => {
                    commit(storeMutation.setUpcomingEventList, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.saveUpcomingEvent]: wrapAction(storeAction.saveUpcomingEvent, ({ commit, state, rootGetters }, eventId) => {
        return rootGetters[storeGetters.communityIdPromise]
            .then((communityId) => {
                return axios({
                    url: `${state.baseURL}events/api/saved/${communityId}/${eventId}`,
                    headers: getBasicHeaders(),
                    method: 'POST',
                });
            })
            .then((response) => {
                commit(storeMutation.updateSaveUpcomingEvents, response.data);
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),

    [storeAction.rejectUpcomingEvent]: wrapAction(
        storeAction.rejectUpcomingEvent,
        ({ state, commit, rootGetters }, eventId) => {
            return rootGetters[storeGetters.communityIdPromise]
                .then((communityId) => {
                    return axios({
                        url: `${state.baseURL}events/api/reject/${communityId}/${eventId}`,
                        headers: getBasicHeaders(),
                        method: 'POST',
                    });
                })
                .then((response) => {
                    commit(storeMutation.updateRejectUpcomingEvents, response.data);
                    return response.data;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.sendRemovePostModeration]: async ({ state, commit }, postId) => {
        return axios({
            url: `${state.baseURL}posts/api/post/markModeratedPostAsReviwed/${postId}`,
            headers: getBasicHeaders(),
            method: 'PUT',
        })
            .then((response) => {
                commit(storeMutation.updatePostLocally, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.sendHidePostModeration]: async ({ state, commit }, objectToSave) => {
        return axios({
            url: `${state.baseURL}posts/api/post/markModeratedPostAsHidden`,
            headers: getBasicHeaders(),
            data: { ...objectToSave },
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.deletePostLocally, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getDownloadMemberDirectory]: ({ state, commit, rootGetters }, downloadType) => {
        const communityTypeName = rootGetters[storeGetters.communityName];
        return rootGetters[storeGetters.communityIdPromise]
            .then((communityId) => {
                const requestSource = getAxiosCancelTokenSource();
                const requestObject = {
                    actionName: storeAction.getChapterList,
                    requestSource,
                };
                commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

                return axios({
                    url: `${
                        state.baseURL
                    }communities/api/communities/download-directory/${communityId}/${communityTypeName}/${downloadType}`,
                    headers: getBasicHeaders(),
                    method: 'GET',
                    responseType: 'arraybuffer',
                });
            })
            .then((response) => {
                commit(storeMutation.removeCancelableRequest, storeAction.getDownloadMemberDirectory, { root: true });
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `MemberDirectory.${downloadType}`;
                link.click();
            })
            .catch((err) => {
                //TODO: handle error
                console.log(err);
                throw err;
            });
    },
    [storeAction.getIsPMTeamMember]: ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}communities/api/communities/is-pm-teammember`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setIsPMTeamMember, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getChapterAnnouncement]: ({ rootGetters, state }) => {
        return rootGetters[storeGetters.communityIdPromise]
                .then((communityId) => {
                return axios({
                    url: `${state.baseURL}communities/api/communities/get-connect-announcement/${communityId}`,
                    headers: getBasicHeaders(),
                    method: 'GET',
                });
            });
    },
    [storeAction.getBusinessCommunityId]: async ({ state, commit }) => {
        const promise = new Promise((resolve) => {
            axios({
                url: `${state.baseURL}profiles/api/around-me/get-business-about-community`,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setBusinessCommunityId, response.data);
                    resolve(response.data);
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        });
        const result = await promise;
        return result;
    },
    [storeAction.getUnRegisteredEvents]: async ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}events/api/events/get-all-unregistered-events`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setUnRegisteredEvents, response.data);
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
};

const chapterPageGetters = {
    [storeGetters.activityFeedList]: state => state.activityFeedList,
    [storeGetters.usersCommunitiesList]: state => state.usersCommunitiesList,
    [storeGetters.champsChapters]: (state) => {
        if (state && state.usersCommunitiesList) {
            return state.usersCommunitiesList.filter(community =>
                    community.communityType && community.communityType.toLowerCase() === 'chapter' && community.isAdmin);
        }
    },
    [storeGetters.isPostEditing]: state => postId => !!state.postEdits[postId],
    [storeGetters.isPostChangePending]: state => postId => !!state.postChangesPending[postId],
    [storeGetters.chairMessage]: state => state.chairMessage,
    [storeGetters.errorFetchingCommunityData]: state => state.errorFetchingCommunityData,
    [storeGetters.getShowMoreCallCountForPost]: state => (user) => {
        return (!user.isAdminPageFeed
            ? state.showMoreTriggeredPost
            : state.showMoreTriggeredPostForAdmin
        ).hasOwnProperty(user.postId)
            ? state.showMoreTriggeredPost[user.postId]
            : 0;
    },
    [storeGetters.isHiddenPost]: state => postId => !!state.hiddenPostList[postId],
    [storeGetters.aboutView]: state => state.aboutView,
    [storeGetters.chapterAwards]: state => state.chapterAwards,
    [storeGetters.commentedUsers]: state => state.commentedUsers,

    //end

    // region chapter list
    [storeGetters.chapterList]: state => state.chapterList,
    [storeGetters.allChapterList]: state => state.allChapterList,
    //end
    [storeGetters.getPrimaryChapter]: (state) => {
        if (state.usersCommunitiesList != null) {
            return state.usersCommunitiesList.find(x => x.communityType.toLowerCase() === routerNames.CHAPTER.toLowerCase() && x.isPrimaryChapter);
        }
    },
    [storeGetters.chapterOfficersData]: state => state.chapterOfficersData,
    [storeGetters.aboutView]: state => state.aboutView,
    [storeGetters.transactionHubContent]: state => state.transactionHubContent || {},
    [storeGetters.prospectsList]: state => state.prospectsList,
    [storeGetters.voted]: state => state.voted,
    [storeGetters.likedUsers]: state => state.likedUsers,
    [storeGetters.featureEvents]: state => state.featureEvents,
    [storeGetters.featureEventObject]: (state) => {
        return state.featureEventInEdit && state.featureEvents && state.featureEvents.eventList.length > 0
            ? state.featureEvents.eventList.find(event => event.id === state.featureEventInEdit)
            : featureEventObject();
    },
    [storeGetters.adminFeedList]: state => state.adminFeedList,
    ...fileDragDropGetters,
    ...filesAndMediaGetters,
    ...chapterAdminDetailsGetters,
    [storeGetters.upcomingEventList]: state => state.upcomingEventList,
    [storeGetters.prospectDownloadInProgress]: state => state.prospectDownloadInProgress,
    [storeGetters.getIsCommunityAdmin]: state => state.isCommunityAdmin,
    [storeGetters.getIsCommunityModerated]: state => state.isCommunityModerated,
    [storeGetters.getCommunitySalesforceId]: state => state.communitySalesforceId,
    [storeGetters.getChapterHealthScore]: state => state.chapterHealthScore,
    [storeGetters.getModeratedPostCreated]: state => state.moderatedPostCreated,
    [storeGetters.disableInfiniteScroll]: state => state.disableInfiniteScroll,
    [storeGetters.noMoreActivityToFetch]: state => state.noMoreActivityToFetch,
    [storeGetters.communityInfo]: state => state.communityInfo,
    [storeGetters.businessCommunityId]: state => state.businessCommunityId,
    [storeGetters.isPMTeamMember]: state => state.isPMTeamMember,
    [storeGetters.unRegisteredEvents]: state => state.unRegisteredEvents,
    [storeGetters.chapterMessage]: state => state.chapterMessage,
    [storeGetters.chapterQuickLinks]: state => state.chapterQuickLinks,
    [storeGetters.isMainActivityFeedHidden]: state => state.isMainActivityFeedHidden,
    [storeGetters.isUserMemberOfCommunity]: state => (communityId) => {
        return state.usersCommunitiesList ? state.usersCommunitiesList.some(o => o.communityId === communityId) : false;
    },
};

export default {
    namespaced: true,
    state: {
        initialState: chapterPageState(),
        ...chapterPageState(),
    },
    mutations: { ...chapterPageMutations },
    actions: { ...chapterPageActions },
    getters: { ...chapterPageGetters },
};
